
import React,{useState, useEffect} from 'react';

import '../sidebar.css'
import { Table ,Container} from 'react-bootstrap';
import AddInput from './AddInput';


const AdminTable =()=>{





return ( 

<Container className="table-cont">
<AddInput/>


</Container>


);
}


export default AdminTable;